import React, { useEffect, useState } from 'react';
import { Modal, ModalBody, ModalHeader, Row, Spinner } from 'reactstrap';
import { RETRIEVE_SPECIFIC_TENANT_SALES_REP_ALLOWED_BRAND_DETAILS_API, TENANT_TOGGLE_SALES_REP_ALLOWED_BRAND_API, TENANT_TOGGLE_SALES_REP_ALLOWED_BRAND_PRODUCT_TYPE_API } from '../../api/api_data';
import { fail_retrieve_sales_rep_allowed_brand_details, loading_retrieve_sales_rep_allowed_brand_details, reset_retrieve_sales_rep_allowed_brand_details, success_retrieve_sales_rep_allowed_brand_details } from '../../reducers/auth_tenant/retrieve_sales_rep_allowed_brand_details_Slice';
import { useSelector } from 'react-redux';
import { messageToast } from '../../utils/Utils';
import * as app_consts from "../../utils/app_consts";
import { useDispatch } from 'react-redux';
import { tenant_auth_actions_helper } from '../../actions/actions_helper';
import { COULD_NOT_RETRIEVE_DATA_ERROR_MSG, COULD_NOT_RETRIEVE_DATA_SUCCESS_MSG, TENANT_TOGGLE_SALES_REP_BRAND_ERROR_MSG, TENANT_TOGGLE_SALES_REP_BRAND_PRODUCT_TYPE_ERROR_MSG, TENANT_TOGGLE_SALES_REP_BRAND_PRODUCT_TYPE_SUCCESS_MSG, TENANT_TOGGLE_SALES_REP_BRAND_SUCCESS_MSG } from '../../utils/error_success_messages';
import { BlockHead, BlockTitle, Col } from '../Component';
import { fail_tenant_toggle_sales_rep_brand, loading_tenant_toggle_sales_rep_brand, reset_tenant_toggle_sales_rep_brand, success_tenant_toggle_sales_rep_brand } from '../../reducers/auth_tenant/tenant_toggle_sales_rep_brand_Slice';
import { fail_tenant_toggle_sales_rep_brand_product_type, loading_tenant_toggle_sales_rep_brand_product_type, reset_tenant_toggle_sales_rep_brand_product_type, success_tenant_toggle_sales_rep_brand_product_type } from '../../reducers/auth_tenant/tenant_toggle_sales_rep_brand_product_type_Slice';

const ViewSalesRepsAllowedBrandsModal = ({ isOpen, closeModal, tenant_info, user_info, successFunction, data, mainPageData, setData }) => {

  const dispatch = useDispatch();
  const [page_data, setPageData] = useState([]);
  const [open, setOpen] = useState(isOpen);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [retrieved_data, setRetrievedData] = useState([]);
  const [selected_brand, setSelectedBrand] = useState(data);
  const [selectedToggleRole, setSeletedToggleRole] = useState("");
  const [toggle_loading, setToggleLoading] = useState(false);
  const [toggle_role_error, setToggleRoleError] = useState("");

  const [update_loading, setUpdateLoading] = useState(false);
  const [update_error, setUpdateError] = useState("");

  const [product_type_loading, setProductTypeLoading] = useState(false);
  const [product_type_error, setProductTypeError] = useState("");
  const [selectedProductType, setSelectedProductType] = useState("");



  useEffect(() => {
    if (isOpen && data && mainPageData)
    {
      retrieve_page_data(data, mainPageData?.sales_rep?.id);
      setPageData(mainPageData);
      setSelectedBrand(data);
    }
    setOpen(isOpen);
  }, [isOpen, data, mainPageData]);

  const retrieve_page_data = (brand, sales_rep_id) => {
    setError("");
    // Disaptch


    dispatch(tenant_auth_actions_helper(loading_retrieve_sales_rep_allowed_brand_details, success_retrieve_sales_rep_allowed_brand_details, fail_retrieve_sales_rep_allowed_brand_details, COULD_NOT_RETRIEVE_DATA_ERROR_MSG, COULD_NOT_RETRIEVE_DATA_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_SPECIFIC_TENANT_SALES_REP_ALLOWED_BRAND_DETAILS_API}/${brand}/${sales_rep_id}`));
  };

  // Listener
  const retrieve_sales_rep_allowed_brand_details_listener = useSelector((state) => state.retrieve_sales_rep_allowed_brand_details.retrieve_sales_rep_allowed_brand_details);

  useEffect(() => {
    if (retrieve_sales_rep_allowed_brand_details_listener.status !== app_consts.IDLE)
    {
      if (retrieve_sales_rep_allowed_brand_details_listener.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        if (retrieve_sales_rep_allowed_brand_details_listener.status === app_consts.FAIL)
        {
          setLoading(false);
          setError(retrieve_sales_rep_allowed_brand_details_listener.message);
          messageToast(retrieve_sales_rep_allowed_brand_details_listener.message, app_consts.FAIL);
        } else if (retrieve_sales_rep_allowed_brand_details_listener.status === app_consts.SUCCESS)
        {

          setRetrievedData(retrieve_sales_rep_allowed_brand_details_listener.data);
          const timer = setTimeout(() => {
            setLoading(false);
          }, 1000);

          return () => clearTimeout(timer); // cleanup in case the component unmounts
        }
        dispatch(reset_retrieve_sales_rep_allowed_brand_details());
      }
    }
  }, [retrieve_sales_rep_allowed_brand_details_listener]);


  const toggle_brand = (role) => {
    setSeletedToggleRole(role);
    setToggleRoleError("");
    dispatch(tenant_auth_actions_helper(loading_tenant_toggle_sales_rep_brand, success_tenant_toggle_sales_rep_brand, fail_tenant_toggle_sales_rep_brand, TENANT_TOGGLE_SALES_REP_BRAND_ERROR_MSG, TENANT_TOGGLE_SALES_REP_BRAND_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${TENANT_TOGGLE_SALES_REP_ALLOWED_BRAND_API}`, { sales_rep_id: page_data?.sales_rep?.id, brand: role }));
  };

  // Listener
  const tenant_toggle_sales_rep_brand_listener = useSelector((state) => state.tenant_toggle_sales_rep_brand.tenant_toggle_sales_rep_brand);

  useEffect(() => {
    if (tenant_toggle_sales_rep_brand_listener.status !== app_consts.IDLE)
    {
      if (tenant_toggle_sales_rep_brand_listener.status === app_consts.LOADING)
      {
        setToggleLoading(true);
      } else
      {
        setToggleLoading(false);
        if (tenant_toggle_sales_rep_brand_listener.status === app_consts.FAIL)
        {
          if (open)
          {
            messageToast(tenant_toggle_sales_rep_brand_listener.message, app_consts.FAIL);
          }
          setToggleRoleError(tenant_toggle_sales_rep_brand_listener.message);
        } else if (tenant_toggle_sales_rep_brand_listener.status === app_consts.SUCCESS)
        {
          if (open)
          {
            messageToast(TENANT_TOGGLE_SALES_REP_BRAND_SUCCESS_MSG, app_consts.SUCCESS);
          }
          setPageData({ ...page_data, sales_rep: tenant_toggle_sales_rep_brand_listener.data });
          setData({ ...page_data, sales_rep: tenant_toggle_sales_rep_brand_listener.data });
        }
        dispatch(reset_tenant_toggle_sales_rep_brand());
      }
    }
  }, [tenant_toggle_sales_rep_brand_listener]);

  const toggle_product_type = (product_type) => {
    setProductTypeError('');
    setSelectedProductType(product_type);
    // Dispatch
    dispatch(tenant_auth_actions_helper(loading_tenant_toggle_sales_rep_brand_product_type, success_tenant_toggle_sales_rep_brand_product_type, fail_tenant_toggle_sales_rep_brand_product_type, TENANT_TOGGLE_SALES_REP_BRAND_PRODUCT_TYPE_ERROR_MSG, TENANT_TOGGLE_SALES_REP_BRAND_PRODUCT_TYPE_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${TENANT_TOGGLE_SALES_REP_ALLOWED_BRAND_PRODUCT_TYPE_API}`, { sales_rep_id: page_data?.sales_rep?.id, brand: selected_brand, product_type: product_type }));
  };

  // Listener
  const tenant_toggle_sales_rep_brand_product_type_listener = useSelector((state) => state.tenant_toggle_sales_rep_brand_product_type.tenant_toggle_sales_rep_brand_product_type);

  useEffect(() => {
    if (tenant_toggle_sales_rep_brand_product_type_listener.status !== app_consts.IDLE)
    {
      if (tenant_toggle_sales_rep_brand_product_type_listener.status === app_consts.LOADING)
      {
        setProductTypeLoading(true);
      } else
      {
        setProductTypeLoading(false);
        if (tenant_toggle_sales_rep_brand_product_type_listener.status === app_consts.FAIL)
        {
          if (open)
          {
            messageToast(tenant_toggle_sales_rep_brand_product_type_listener.message, app_consts.FAIL);
          }
          setProductTypeError(tenant_toggle_sales_rep_brand_product_type_listener.message);
        } else if (tenant_toggle_sales_rep_brand_product_type_listener.status === app_consts.SUCCESS)
        {
          if (open)
          {
            messageToast(TENANT_TOGGLE_SALES_REP_BRAND_SUCCESS_MSG, app_consts.SUCCESS);
          }
          setPageData({ ...page_data, sales_rep: tenant_toggle_sales_rep_brand_product_type_listener.data });
          setData({ ...page_data, sales_rep: tenant_toggle_sales_rep_brand_product_type_listener.data });
        }
        dispatch(reset_tenant_toggle_sales_rep_brand_product_type());
      }
    }
  }, [tenant_toggle_sales_rep_brand_product_type_listener]);

  return (
    <>

      <Modal isOpen={open} toggle={update_loading || loading || toggle_loading ? "" : closeModal} className="modal-dialog-centered" size={"lg "}>
        <ModalHeader toggle={update_loading || loading || toggle_loading ? "" : closeModal}>Sales Rep Brand {selected_brand ? `(${selected_brand})` : ""}</ModalHeader>
        <ModalBody>
          {
            loading ?
              <>
                <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                  <div className="text-soft fw-bold" style={{ fontSize: 24, marginTop: "90px" }}>Retrieveing Sales Rep Brand Details...</div>
                  <div className="nk-loader mt-2  w-70 m-auto "></div>
                </div>
              </>
              :
              <>
                {
                  error ?
                    <>
                      <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                        <div className="text-soft fw-bold" style={{ fontSize: 16, marginTop: "90px" }}>{error}</div>
                      </div>
                    </>
                    :
                    <>
                      <div className="mt-4">
                        <BlockHead>
                          <BlockTitle tag="h6">Brand</BlockTitle>
                        </BlockHead>

                        <Row className="gy-4">
                          <Col md={12}>
                            <div className="p-3 border rounded shadow-sm bg-light">
                              <div className="d-flex align-items-center justify-content-between">
                                <label className="form-label mb-0 fw-semibold fs-6 text-dark">
                                  {selected_brand}
                                </label>

                                {(user_info?.roles?.includes(app_consts.ADMINISTRATOR) ||
                                  user_info?.roles?.includes(app_consts.UPDATE_BUDGET_ALLOCATION)) ? (
                                  <div className="form-check form-switch d-flex align-items-center">
                                    {update_loading && retrieved_data?.sales_rep?.allowed_products?.includes(selected_brand) ? (
                                      <Spinner size="sm" color="primary" className="me-2" />
                                    ) : (
                                      <>
                                        <input
                                          type="checkbox"
                                          className="form-check-input me-2"
                                          id="selected_brand"
                                          disabled={update_loading}
                                          checked={retrieved_data?.sales_rep?.allowed_products?.includes(selected_brand)}
                                          onClick={() => toggle_brand(selected_brand)}
                                        />
                                        <label
                                          className={`form-check-label fs-6 ${retrieved_data?.sales_rep?.allowed_products?.includes(selected_brand) ? "text-success fw-medium" : "text-muted"
                                            }`}
                                          htmlFor="selected_brand"
                                        >
                                          {retrieved_data?.sales_rep?.allowed_products?.includes(selected_brand) ? "Enabled" : "Disabled"}
                                        </label>
                                      </>
                                    )}
                                  </div>
                                ) : (
                                  <div className="mt-1">
                                    <span
                                      className={`fs-6 ${retrieved_data?.sales_rep?.allowed_products?.includes(selected_brand) ? "text-success fw-medium" : "text-muted"
                                        }`}
                                    >
                                      {retrieved_data?.sales_rep?.allowed_products?.includes(selected_brand) ? "Enabled" : "Disabled"}
                                    </span>
                                  </div>
                                )}

                                {toggle_role_error && (
                                  <div className="mt-2 text-danger small">
                                    <em className="icon ni ni-alert-circle me-1"></em>
                                    {toggle_role_error}
                                  </div>
                                )}
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                      <div className="mt-4 ">
                        <BlockHead>
                          <BlockTitle tag="h6">Product Types</BlockTitle>
                        </BlockHead>

                        <Row className="gy-4">
                          {
                            retrieved_data?.product_types?.map((product_type) => {

                              // Return Product Types
                              const existing_product_types = retrieved_data?.sales_rep?.allowed_product_types?.find((prod) => prod?.brand === selected_brand) || [];

                              return (
                                <>
                                  <Col md={6}>
                                    <div className="p-3 border rounded shadow-sm bg-light">
                                      <div className="d-flex align-items-center justify-content-between">
                                        <label className="form-label mb-0 fw-semibold fs-6 text-dark">
                                          {product_type}
                                        </label>
                                        {
                                          (user_info?.roles?.includes(app_consts.ADMINISTRATOR) ||
                                            user_info?.roles?.includes(app_consts.UPDATE_BUDGET_ALLOCATION)) && retrieved_data?.sales_rep?.allowed_products?.includes(selected_brand) ? (
                                            <>
                                              <div className="form-check form-switch d-flex align-items-center">
                                                {product_type_loading && selectedProductType === product_type ? (
                                                  <Spinner size="sm" color="primary" className="me-2" />
                                                ) : (
                                                  <>
                                                    <input
                                                      type="checkbox"
                                                      className="form-check-input me-2"
                                                      id="product_type"
                                                      disabled={product_type_loading}
                                                      checked={existing_product_types?.allowed_product_types?.includes(product_type)}
                                                      onClick={() => toggle_product_type(product_type)}
                                                    />
                                                    <label
                                                      className={`form-check-label fs-6 ${existing_product_types?.allowed_product_types?.includes(selected_brand) ? "text-success fw-medium" : "text-muted"
                                                        }`}
                                                      htmlFor="product_type"
                                                    >
                                                      {existing_product_types?.allowed_product_types?.includes(product_type) ? "Enabled" : "Disabled"}
                                                    </label>
                                                  </>
                                                )}
                                              </div>
                                            </>
                                          )
                                            :
                                            <>
                                              <div className="mt-1">
                                                <span
                                                  className={`fs-6 ${existing_product_types?.allowed_product_types?.includes(product_type) ? "text-success fw-medium" : "text-muted"
                                                    }`}
                                                >
                                                  {existing_product_types?.allowed_product_types?.includes(product_type) ? "Enabled" : "Disabled"}
                                                </span>
                                              </div>
                                            </>
                                        }
                                      </div>

                                      {product_type_error && selectedProductType === product_type && (
                                        <div className="mt-2 text-danger small">
                                          <em className="icon ni ni-alert-circle me-1"></em>
                                          {product_type_error}
                                        </div>
                                      )}
                                    </div>
                                  </Col>
                                </>
                              );
                            })
                          }
                        </Row>
                      </div>
                    </>
                }
              </>
          }
        </ModalBody>
      </Modal>
    </>
  );
};

export default ViewSalesRepsAllowedBrandsModal;